import React, { useEffect, useState } from 'react';
import HomePage from 'components/page-home';
import './styles/project.scss';
import { createBrowserHistory } from 'history';
import { isWindow } from './utility';
window.myhistory = createBrowserHistory();

export default function Home({ location }) {
  const [browser , setBrowser] = useState();
  useEffect(() => {
    const canvasScript = document.createElement('script');
    canvasScript.src =
      'https://cannabition-staging.firebaseapp.com/js/smoke.js'; //TODO: change me
    document.head.appendChild(canvasScript);
    try {
      const ua = window.navigator.userAgent;
      const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
      const webkit = !!ua.match(/WebKit/i);
      const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
      setBrowser(iOSSafari);
      console.log(iOSSafari);
    } catch (error) {

    }
  }, []);
  if (isWindow() && !window.location.hash) {
    window.location.hash = '#welcome';
  }
  const [hash, setHash] = useState(window.location.hash);

  function locationHashChanged() {
    setHash(window.location.hash);
  }

  window.addEventListener('hashchange', locationHashChanged);
  return (
    <>
      <HomePage hash={hash} browser={browser}/>
    </>
  );
}
